import React from "react";
import SuperstarAuditionNav from "../SuperstarAuditionNav/SuperstarAuditionNav";
import PendingAuditionSliderStar from "../PendingAuditionSliderStar/PendingAuditionSliderStar";

const SuperstarAuditionPending = () => {
  return (
    <>
      <SuperstarAuditionNav />

      <div className="mt-3">
        
        <PendingAuditionSliderStar />
      </div>
    </>
  );
};

export default SuperstarAuditionPending;
